import React from "react";
function AllResultsContainer(props) {
  return (
    <React.Fragment>
      <div className="searchbox">
        <input
          aria-label="Search for SCOE staff"
          disabled={props.loading}
          name="searchString"
          onChange={props.inputHandleOnChange}
          className="input"
          placeholder={ props.placeholder || "Search (name, title, phone, dept.)"}
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
        />
        {/* <div>{props.count} matches</div> */}
      </div>
      {props.children}
    </React.Fragment>
  );
}

export default AllResultsContainer;
